import { useTexts } from '@/feature/lang';
import { getUtcOffsetWithSign } from '@/util/time';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Box } from '../Box';
import { Input } from '../Form';
import HelpText from '../HelpText';
import Translate from '../Translate';
import { useDateRange } from './DateRangeProvider';
import DateRangeStepper from './DateRangeStepper';

const Filter = () => {
  const texts = useTexts();
  const { activePreset, value, setValue } = useDateRange();
  const [localValue, setLocalValue] = useState(value);
  const [from, to] = localValue;

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <div>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography variant="h4" sx={{ flex: 1 }}>
          {activePreset?.label ?? (
            <Translate text={texts.component.dateRange.custom} />
          )}
        </Typography>
        <DateRangeStepper />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexFlow: 'wrap' }}>
        <Input
          type="datetime-local"
          value={from}
          onChange={(e) => setLocalValue([e.target.value, to])}
          onBlur={() => setValue(localValue)}
          label={texts.component.dateRange.from.fieldLabel}
          size="medium"
          margin="none"
          sx={{ width: '200px' }}
          inputProps={{
            max: to,
          }}
        />
        <Input
          type="datetime-local"
          value={to}
          onChange={(e) => setLocalValue([from, e.target.value])}
          onBlur={() => setValue(localValue)}
          label={texts.component.dateRange.to.fieldLabel}
          size="medium"
          margin="none"
          sx={{ width: '200px' }}
          inputProps={{
            min: from,
          }}
        />
      </Box>
      <Box mt={2}>
        <HelpText
          text={texts.component.dateRange.usedTimezone}
          values={{ offset: getUtcOffsetWithSign() }}
        />
      </Box>
    </div>
  );
};

export default Filter;
